import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import productData from "../data/brother-products.json";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const getImage = (item) => {
    if (!item) return "/assets/img/placeholder.png";

    if (Array.isArray(item.imageUrl) && item.imageUrl.length > 0) {
      return item.imageUrl[0];
    }

    if (typeof item.imageUrl === "string" && item.imageUrl.trim()) {
      return item.imageUrl;
    }

    return "/assets/img/placeholder.png";
  };

  useEffect(() => {
    setProducts(productData);
  }, []);

  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((i) => i.id === product.id);

    if (existing) existing.quantity++;
    else cart.push({ ...product, quantity: 1 });

    sessionStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cart-updated"));
    toast.success(`${product.name} added to cart!`);
  };

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  const productsWithExtras = useMemo(() => {
    return products.map((item) => ({
      ...item,
      rating: (Math.random() * 1 + 4).toFixed(1),
      features: ["Compatible", "Eco Print", "Fast Delivery", "Premium Quality"]
        .sort(() => 0.5 - Math.random())
        .slice(0, 2),
      formattedCategory: formatCategory(item.category),
    }));
  }, [products]);

  return (
    <section className="supplies-section">
      <div className="supplies-container">
        {/* Heading */}
        <div className="supplies-heading">
          <h2>Ink, Toner & Paper Essentials</h2>
          <p>
            Reliable and high-quality printing supplies for home, office and
            professional use. Shop premium ink cartridges, toner refills and
            paper packs at the best price.
          </p>
        </div>

        {/* GRID */}
        <div className="supplies-grid">
          {productsWithExtras.map((item) => (
            <div key={item.id} className="sup-card">
              {/* IMAGE */}
              <Link to={`/product-details/${item.id}`} className="sup-img-box">
                <img src={getImage(item)} alt={item.name} />
              </Link>

              {/* CONTENT */}
              <div className="sup-content">
                <p className="sup-category">{item.formattedCategory}</p>

                <Link to={`/product-details/${item.id}`} className="sup-title">
                  {item.name}
                </Link>

                <div className="sup-tags">
                  {item.features.map((tag, i) => (
                    <span key={i} className="sup-tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="sup-footer">
                  <span className="sup-price">${item.price}</span>
                  <button
                    className="sup-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add to Cart
                  </button>
                </div>

                <div className="sup-rating">
                  ⭐ {item.rating} • <span className="in-stock">In Stock</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .supplies-section {
          background: #f9fbfd;
          padding: 70px 0;
        }

        .supplies-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
        }

        /* Heading */
        .supplies-heading {
          text-align: center;
          margin-bottom: 45px;
        }

        .supplies-heading h2 {
          font-size: 32px;
          font-weight: 800;
          color: #1a1a1a;
        }

        .supplies-heading p {
          max-width: 650px;
          margin: 12px auto 0;
          color: #666;
          font-size: 15px;
          line-height: 1.6;
        }

        /* Grid */
        .supplies-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 26px;
        }

        /* Card */
        .sup-card {
          background: #ffffff;
          border: 1px solid #e6e9ee;
          border-radius: 14px;
          transition: 0.25s ease;
          overflow: hidden;
        }

        .sup-card:hover {
          border-color: #d1d8f0;
          box-shadow: 0 6px 20px rgba(0,0,0,0.06);
          transform: translateY(-4px);
        }

        /* Image */
        .sup-img-box {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
          padding: 22px;
          height: 180px;
        }

        .sup-img-box img {
          width: 70%;
          transition: 0.3s ease;
        }

        .sup-card:hover img {
          transform: scale(1.07);
        }

        /* Content */
        .sup-content {
          padding: 18px;
        }

        .sup-category {
          font-size: 11px;
          color: #888;
          text-transform: uppercase;
          font-weight: 600;
          margin-bottom: 6px;
        }

        .sup-title {
          font-size: 17px;
          font-weight: 700;
          color: #111;
          text-decoration: none;
          line-height: 1.4;
          margin-bottom: 10px;
          display: block;
        }

        /* Tags */
        .sup-tags {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 16px;
        }

        .sup-tag {
          background: #eef5ff;
          color: #0b61d6;
          padding: 5px 10px;
          font-size: 11px;
          border-radius: 8px;
          font-weight: 600;
        }

        /* Footer */
        .sup-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .sup-price {
          font-size: 20px;
          font-weight: 800;
          color: #0b61d6;
        }

        .sup-btn {
          background: #0b61d6;
          color: #fff;
          padding: 8px 16px;
          border: none;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          transition: 0.25s;
        }

        .sup-btn:hover {
          background: #084eb3;
          transform: translateY(-2px);
        }

        /* Rating */
        .sup-rating {
          padding-top: 10px;
          border-top: 1px solid #eee;
          font-size: 13px;
          color: #333;
        }

        .in-stock {
          color: #0ca52a;
          font-weight: 600;
        }
      `}</style>
    </section>
  );
};

export default DealsOne;
